import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "Slices/Response/responseSlice";
import { setToast, setLoading, setModal } from "Slices/uiSlice";
import { adminTipoAprendizaje, getTiposAprendizaje } from "Services/tipo_aprendizaje";

const initialState = {
    tipoAprendizajes: [],
    tipoAprendizaje: {
        nombre: '',
        estado: 1,
    },
}

export const tipoAprendizajeSlice = createSlice({
    name: 'tipoAprendizaje',
    initialState,
    reducers: {
        setTiposAprendizaje: (state, action) => {
            state.tipoAprendizajes = action.payload;
        },
        setTipoAprendizaje: (state, action) => {
            state.tipoAprendizaje = action.payload ?? initialState.tipoAprendizaje;
        },
        updateTipoAprendizajeField: (state, action) => {
            const { name, value } = action.payload;
            state.tipoAprendizaje[name] = value;
        },
        resetTipoAprendizaje: () => initialState,
    }
});

export const fetchTiposAprendizaje = createAsyncThunk(
    'tipoAprendizaje/fetchTiposAprendizaje',
    async (_, { dispatch }) => {
        const tipoAprendizajeRes = await getTiposAprendizaje();
        dispatch(setTiposAprendizaje(tipoAprendizajeRes));
    }
);

export const mergeTipoAprendizaje = createAsyncThunk(
    'tipoAprendizaje/merge',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const tipoAprendizajeRes = await adminTipoAprendizaje(data);
        dispatch(setResponse(tipoAprendizajeRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(fetchTiposAprendizaje());
        dispatch(resetTipoAprendizaje())
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const { setTipoAprendizaje, setTiposAprendizaje, updateTipoAprendizajeField, resetTipoAprendizaje } = tipoAprendizajeSlice.actions;
export default tipoAprendizajeSlice.reducer;
